import { render } from "./QualificationView.vue?vue&type=template&id=cf05e0d0&scoped=true"
import script from "./QualificationView.vue?vue&type=script&lang=js"
export * from "./QualificationView.vue?vue&type=script&lang=js"

import "./QualificationView.vue?vue&type=style&index=0&id=cf05e0d0&scoped=true&lang=scss"
import "./QualificationView.vue?vue&type=style&index=1&id=cf05e0d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf05e0d0"]])

export default __exports__